import { AssetPurchase } from "../../../../models/assetpurchase.model";
import { ModalPropsWithGroupAssetPurchase } from "../../../../types/modalProps";
import { PurchasePanelMode } from "../../../../types/purchasePanelMode";
import { responseHero } from "../../../../utils/axiosInterceptor";
import { toast } from "react-toastify";

type RemoveCoinPurchaseModalProps = Omit<ModalPropsWithGroupAssetPurchase, "user"> & {
    mode?: PurchasePanelMode;
};

const RemoveCoinPurchaseModal = ({ title, showModal, closeModal, row, handleStateChange, mode = 'deposit' } : RemoveCoinPurchaseModalProps) => {

    const isHolding = mode === 'holding';

    const buildDeleteUrl = (id: number) =>
        isHolding
            ? `${process.env.REACT_APP_API_URL}/holdassetp/${id}`
            : `${process.env.REACT_APP_API_URL}/assetp/${id}`;

    const removeRow = async (row: AssetPurchase | undefined) => {
        if(!row) return;
        await responseHero.delete(buildDeleteUrl(row.id)).then((response) => {
            closeModal()
            handleStateChange()
            toast.success("Sor törölve!")
        }).catch(error => {
            console.error(error.response?.data);
            closeModal()

            toast.error("Hiba a sor törlése közben!")
        })
    }

            return (
            <>
                {(showModal && row) && (
                    <>
                    <div className="flex justify-center items-center overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
                        <div className="relative w-auto my-6 mx-auto max-w-3xl">
                            <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
                                <div className="flex items-start justify-between p-5 border-b border-solid border-gray-300 rounded-t ">
                                    <h3 className="text-3xl text-dark-blue font=semibold">{title}</h3>
                                    <span className={`px-3 py-1 rounded-full text-xs font-semibold self-center ${
                                        isHolding ? 'bg-amber-600 text-white' : 'bg-dark-blue text-cream'
                                    }`}>
                                        {isHolding ? 'Holding' : 'Normál'}
                                    </span>
                                </div>
                                <div className="relative p-6 flex-auto">
                                    <p className="text-dark-blue">Biztos vagy benne, hogy törlöd ezt a befektetést?</p>
                                    <p className="font-bold text-error">
                                        {isHolding
                                            ? "Figyelem: Ezzel törlődik a holding befizetéshez társított vásárlás is a Crypto-nyilvántartóból!"
                                            : "Figyelem: Ezzel törlődik a befizetéshez társított vásárlás is a Crypto-nyilvántartóból!"}
                                    </p>
                                    <p className="text-brown text-sm">A sort létrehozták: <b>{row.date.toString().split('T')[0]}</b></p>
                                </div>
                                <div className="flex items-center justify-end p-6 border-t border-solid border-blueGray-200 rounded-b">
                                <button
                                    className="text-red-500 background-transparent font-bold uppercase px-6 py-2 text-sm outline-none focus:outline-none mr-1 mb-1"
                                    type="button"
                                    onClick={closeModal}
                                >
                                    Mégse
                                </button>
                                <button
                                    className="text-cream bg-dark-blue font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1"
                                    type="button"
                                    onClick={() => removeRow(row)}
                                >
                                    Törlés
                                </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    </>
                )}
            </>
        );
}

export default RemoveCoinPurchaseModal;